const translations = {
    uploaded: 'Uploaded'
};

export default translations;
